import { IonIcon } from '@ionic/react'
import { Card, CardActions, CardContent, CardHeader } from '@mui/material'
import { carOutline, helpOutline, receiptOutline } from 'ionicons/icons'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import Button from '../../components/actions/Button'
import useUser from '../../contexts/hooks/useUser'
import { useContract } from '../../hooks/useContract'
import { trpc } from '../../modules/trpc'
import PageWrapper from '../../wrappers/pageWrapper/PageWrapper'

interface ContactModalProps {}

const Contact: React.FC<ContactModalProps> = () => {
	const { t } = useTranslation('pages_contact')
	const { user } = useUser()
	const [state, setState] = useState({ isLoading: true, isOwner: false })

	const history = useHistory()

	const { contractData: contractInfo } = useContract()

	const { data: synerallUser } = trpc.synerall.userByPid.useQuery(
		{ personalId: user?.personalId ?? '' },
		{ enabled: user?.personalId !== undefined }
	)

	useEffect(() => {
		if (contractInfo && synerallUser) {
			setState({ isLoading: false, isOwner: synerallUser.Id === contractInfo?.CustomerID })
		}
	}, [contractInfo, synerallUser])

	return (
		<PageWrapper page='contact'>
			<div className='flex flex-col pb-[1.4rem] gap-3'>
				{!state.isLoading && state.isOwner && (
					<Card>
						<CardHeader
							sx={{ fontSize: 30 }}
							titleTypographyProps={{ variant: 'h5' }}
							avatar={<IonIcon icon={carOutline} />}
							title={t('moveout.title')}
						/>
						<CardContent sx={{ paddingBottom: 0, paddingTop: 0 }}>
							{t('moveout.description')}
						</CardContent>
						<CardActions sx={{ justifyContent: 'center' }}>
							<Button
								style={{ width: '100%' }}
								size='large'
								disabled={!state.isOwner}
								onClick={() => history.push('/contact/move-out')}
							>
								{t('moveout.cta')}
							</Button>
						</CardActions>
					</Card>
				)}

				{!state.isLoading && state.isOwner && (
					<Card>
						<CardHeader
							sx={{ fontSize: 30 }}
							titleTypographyProps={{ variant: 'h5' }}
							avatar={<IonIcon icon={receiptOutline} />}
							title={t('invoiceExtension.title')}
						/>
						<CardContent sx={{ paddingBottom: 0, paddingTop: 0 }}>
							{t('invoiceExtension.description')}
						</CardContent>
						<CardActions sx={{ justifyContent: 'center' }}>
							<Button
								style={{ width: '100%' }}
								size='large'
								onClick={() => history.push('/contact/invoice-extension')}
								disabled={!state.isOwner}
							>
								{t('invoiceExtension.cta')}
							</Button>
						</CardActions>
					</Card>
				)}

				<Card>
					<CardHeader
						sx={{ fontSize: 30 }}
						titleTypographyProps={{ variant: 'h5' }}
						avatar={<IonIcon icon={helpOutline} />}
						title={t('general.title')}
					/>
					<CardContent className='py-0'>{t('general.description')}</CardContent>
					<CardActions sx={{ justifyContent: 'center' }}>
						<Button
							style={{ width: '100%' }}
							size='large'
							onClick={() => history.push('/contact/general')}
						>
							{t('general.cta')}
						</Button>
					</CardActions>
				</Card>
			</div>
		</PageWrapper>
	)
}

export default Contact
